/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Wirtschaftsid_TitleInputs */

const en_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Identification Number`)
};

const de_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschafts-Identifikationsnummer`)
};

const fr_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro d'identification économique`)
};

const es_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de identificación empresarial`)
};

const it_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di identificazione aziendale`)
};

const nl_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijfsidentificatienummer`)
};

const pl_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numer identyfikacji gospodarczej`)
};

const fi_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritystunnusnumero`)
};

const da_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhvervsidentifikationsnummer`)
};

const sv_impressum_wirtschaftsid_title = /** @type {(inputs: Impressum_Wirtschaftsid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Företagsidentifikationsnummer`)
};

/**
* | output |
* | --- |
* | "Business Identification Number" |
*
* @param {Impressum_Wirtschaftsid_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_wirtschaftsid_title = /** @type {((inputs?: Impressum_Wirtschaftsid_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Wirtschaftsid_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_wirtschaftsid_title(inputs)
	if (locale === "fr") return fr_impressum_wirtschaftsid_title(inputs)
	if (locale === "es") return es_impressum_wirtschaftsid_title(inputs)
	if (locale === "it") return it_impressum_wirtschaftsid_title(inputs)
	if (locale === "nl") return nl_impressum_wirtschaftsid_title(inputs)
	if (locale === "pl") return pl_impressum_wirtschaftsid_title(inputs)
	if (locale === "fi") return fi_impressum_wirtschaftsid_title(inputs)
	if (locale === "da") return da_impressum_wirtschaftsid_title(inputs)
	if (locale === "sv") return sv_impressum_wirtschaftsid_title(inputs)
	return en_impressum_wirtschaftsid_title(inputs)
});